import { useData } from '@/contexts/data-context/use-data';
import { Button } from '@/design-system/button/button';
import { TransactionDetailsDrawerWrapper } from '@/pages/transactions/components/transaction-details-drawer/transaction-details-drawer-wrapper';
import { InvoiceEvidenceView, TransactionView } from '@/types/entity-types';
import * as Sentry from '@sentry/react';
import { ReactNode, useState } from 'react';

type TransactionDrawerTriggerProps = {
  rowEvidence: InvoiceEvidenceView;
  children: ReactNode;
};

export const TransactionDrawerTrigger = ({ rowEvidence, children }: TransactionDrawerTriggerProps) => {
  const [selectedTransaction, setSelectedTransaction] = useState<TransactionView | undefined | null>(null);
  const { data, isLoading } = useData();

  return (
    <>
      <Button
        variant="default"
        isLoading={isLoading}
        onClick={async () => {
          if (!hasTransactionObject(rowEvidence)) {
            Sentry.captureMessage(
              'Transaction drawer trigger clicked on an evidence object without a linked transaction',
              {
                extra: {
                  rowEvidenceId: rowEvidence.id,
                  evidenceTransactionId: rowEvidence.transaction?.id,
                },
              },
            );

            return;
          }

          setSelectedTransaction(rowEvidence.transaction);
        }}
      >
        {children}
      </Button>

      {data?.categories && data?.transactions && selectedTransaction && (
        <TransactionDetailsDrawerWrapper
          selectedTransaction={selectedTransaction}
          transactions={data.transactions}
          categories={data.categories}
          isNavVisible={false}
          onCloseDrawer={() => setSelectedTransaction(null)}
          onChangeSelectedTransaction={() => {}}
        />
      )}
    </>
  );
};

const hasTransactionObject = (
  evidence: InvoiceEvidenceView,
): evidence is InvoiceEvidenceView & { transaction: TransactionView } => {
  return evidence.transaction !== undefined;
};
